import withTrackedMouseEvents from "app/pages/sales-intelligence/hoc/withTrackedMouseEvents";
import HomeDataCard from "app/pages/sales-intelligence/pages/home/components/common/HomeDataCard/HomeDataCard";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";

const HomeDataCardTracked = withTrackedMouseEvents(HomeDataCard, homePageTrackingService.cards.card);

export default HomeDataCardTracked;
